import { cn } from '../../../lib/utils';
import { primaryText, secondaryText } from '../../../styling/stylingHelper';

/**
 * Small KPI tile used across the super-admin pages (AI Checker, Setup Score, Voice Agent).
 * The admin section deliberately doesn't use the app-wide `ui/StatCard` — that one is a
 * heavier card requiring an icon; this is the compact stat tile the admin dashboards share.
 */
export const StatTile = ({
  label,
  value,
  sub,
  tone = 'neutral',
}: {
  label: string;
  value: string;
  sub?: string;
  tone?: 'neutral' | 'good' | 'warn' | 'bad';
}) => {
  const toneClass =
    tone === 'good' ? 'text-emerald-600 dark:text-emerald-400'
    : tone === 'warn' ? 'text-orange-600 dark:text-orange-400'
    : tone === 'bad' ? 'text-red-600 dark:text-red-400'
    : primaryText;
  return (
    <div className="rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50/60 dark:bg-gray-800/30 p-3">
      <div className={cn(secondaryText, 'text-[10px] uppercase tracking-wide')}>{label}</div>
      <div className={cn('text-lg font-bold tabular-nums mt-0.5', toneClass)}>{value}</div>
      {sub && <div className={cn(secondaryText, 'text-[10px] mt-0.5')}>{sub}</div>}
    </div>
  );
};
